import _ from 'lodash';
import {
    FETCH_STATISTICS_INFO,
    FAIL_FETCH_STATISTICS_INFO,
    SET_STATISTICS_INFO,
    ADD_STATISTICS_INFO,
    FAIL_ADD_STATISTICS_INFO,
    SUCCESS_ADD_STATISTICS_INFO,
    UPD_STATISTICS_INFO,
    FAIL_UPD_STATISTICS_INFO,
    SUCCESS_UPD_STATISTICS_INFO,
    DEL_STATISTICS_INFO,
    FAIL_DEL_STATISTICS_INFO,
    SUCCESS_DEL_STATISTICS_INFO,
    SET_STATISTICS_STATUS,
    RESET_STATISTICS_STATUS,
    RESET_PROCESS_ERROR,
} from "../actions";


const initialState = {
    isFetching : false,
    error : false,
    isProcessError : false,
    statisticsInfo : [],
    aggregateDivide : [],
    conditionDivide : [],
    outputItem : [],
    currentFormValues : undefined,
    defaultCurrentValues:undefined,
    isUpdateValues:undefined
};
export default function statisticsSettings(state = initialState, action) {
    let ret = Object.assign({}, state, {});
    switch (action.type) {
        case FETCH_STATISTICS_INFO:
            ret.isFetching = true;
            return ret;
        case FAIL_FETCH_STATISTICS_INFO:
            ret.isFetching = false;
            ret.error = action.payload.err;
            ret.isProcessError = true;
            return ret;
        case SET_STATISTICS_INFO:
            ret = Object.assign({}, state, action.payload.data);
            ret.isFetching = false;
            return ret;
        case ADD_STATISTICS_INFO:
            ret.isFetching = true;
            return ret;
        case FAIL_ADD_STATISTICS_INFO:
            ret.isFetching = false;
            ret.error = action.payload.err;
            ret.isProcessError = true;
            return ret;
        case SUCCESS_ADD_STATISTICS_INFO:
            if(ret.statisticsInfo.length){
                const targetIndex = _.findIndex(ret.statisticsInfo,['value','NEW']);
                ret.statisticsInfo[targetIndex].value = "U_"+action.payload.newid;
            }
            ret.isFetching = false;
            return ret;
        case UPD_STATISTICS_INFO:
            ret.isFetching = true;
            return ret;
        case FAIL_UPD_STATISTICS_INFO:
            ret.isFetching = false;
            ret.error = action.payload.err;
            ret.isProcessError = true;
            return ret;
        case SUCCESS_UPD_STATISTICS_INFO:
            ret.isFetching = false;
            return ret;
        case DEL_STATISTICS_INFO:
            ret.isFetching = true;
            return ret;
        case FAIL_DEL_STATISTICS_INFO:
            ret.isFetching = false;
            ret.error = action.payload.err;
            ret.isProcessError = true;
            return ret;
        case SUCCESS_DEL_STATISTICS_INFO:
            ret.isFetching = false;
            return ret;
        case SET_STATISTICS_STATUS:
            return Object.assign({}, state, action.payload);
        case RESET_STATISTICS_STATUS:
            Object.keys(initialState).forEach((keys)=>{
                ret[keys] = initialState[keys];
            });
            return ret;
        case RESET_PROCESS_ERROR:
            ret.isProcessError = false;
            return ret;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/statistics.js